module.exports = __webpack_public_path__ + "static/02e6428184f50fa26965b6392acc19a8.png";